import * as PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import * as styles from './styles.scss'

export default function Container(props) {
  return (
    <div className={classNames(styles.container, props.className)}>
      {props.children}
    </div>
  )
}

Container.defaultProps = {
  className: '',
}

Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
